export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: 'love-yourself',
    name: '狠狠爱自己',
    description: '学会与自己和解，拥抱不完美的自己，让自我之爱成为一切情感的基础。',
    icon: 'ri-heart-pulse-line',
    articleCount: 8,
  },
  {
    slug: 'love-someone',
    name: '狠狠爱一个人',
    description: '当你决定全力以赴去爱一个人时，世界都会为你让路。探索深度伴侣关系的奥秘。',
    icon: 'ri-heart-add-line',
    articleCount: 10,
  },
  {
    slug: 'express-love',
    name: '深爱表达方式',
    description: '爱不仅在心中，更在行动里。学习用最真实的方式表达你深沉的爱意。',
    icon: 'ri-chat-heart-line',
    articleCount: 7,
  },
  {
    slug: 'passionate-stories',
    name: '炽烈爱情故事',
    description: '真实的情感故事，那些不顾一切、燃烧自我的爱情瞬间，值得被铭记。',
    icon: 'ri-fire-line',
    articleCount: 6,
  },
  {
    slug: 'emotional-growth',
    name: '情感成长之路',
    description: '在爱中成长，在成长中爱。每一段情感经历都是一次心灵的蜕变之旅。',
    icon: 'ri-seedling-line',
    articleCount: 9,
  },
];